import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useParentActivityLessons = (
  country_id,
  exam_board_id,
  subject_id,
  grade_id,
  chapter_id,
  page
) => {
  const formData = {};
  if (country_id) formData.country_id = country_id;
  if (exam_board_id) formData.exam_board_id = exam_board_id;
  if (subject_id) formData.subject_id = subject_id;
  if (grade_id) formData.grade_id = grade_id;
  if (chapter_id) formData.chapter_id = chapter_id;

  if (page) {
    formData.pagination = true;
    formData.page = page;
  }

  return useQuery(
    [
      "selfTestLessons",
      country_id,
      exam_board_id,
      subject_id,
      chapter_id,
      page,
    ],
    async () => {
      const { data } = await axiosPost("/api/cw/viewSelfTestLesson", formData);
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useParentActivityLessons;
